export default __webpack_public_path__ + "static/media/Path3529.df21899c.svg";